import React from 'react';
import { InstagramIcon } from './InstagramIcon';

export const INSTAGRAM_URL = 'https://www.instagram.com/jetcoelectricalcontractor';
export const TIKTOK_URL = 'https://www.tiktok.com/@jetco_electrical';

const TikTokIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.71a8.16 8.16 0 0 0 4.77 1.52V6.79a4.85 4.85 0 0 1-1.84-.1z" />
  </svg>
);

const SOCIALS = [
  { id: 'instagram', label: 'Instagram', href: INSTAGRAM_URL, Icon: InstagramIcon },
  { id: 'tiktok', label: 'TikTok', href: TIKTOK_URL, Icon: TikTokIcon },
];

const SIZES = {
  lg: { circle: 'w-16 h-16', icon: 'w-8 h-8' },
  sm: { circle: 'w-10 h-10', icon: 'w-5 h-5' },
  xs: { circle: 'w-8 h-8', icon: 'w-4 h-4' },
};

export const SocialLinks = ({ size = 'sm', idPrefix, className = 'justify-center' }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    {SOCIALS.map(({ id, label, href, Icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Jetco Electrical on ${label}`}
        className={`${SIZES[size].circle} bg-yellow-400 rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-lg`}
        data-testid={`${idPrefix}-${id}-link`}
      >
        <Icon className={`${SIZES[size].icon} text-black`} />
      </a>
    ))}
  </div>
);
